const validate = (rules, obj, fn) => {
  for (let key in rules) {
    let required = rules[key]
    if (typeof required !== 'string') {
      required = rules[key].required
    }
    if (required) {
      if (!obj[key]) {
        fn.call(obj, key, required)
        return false
      }
    }
    let list = rules[key].patterns || []
    for (let i = 0, len = list.length; i < len; i++) {
      if (!list[i].pattern.test(obj[key])) {
        fn.call(obj, key, list[i].msg)
        return false
      }
    }
  }
  return true
}

const patterns = {
  phone: /^1\d{10}$/,
  money: /^((([1-9]{1}\d{0,8}))|([0]{1}))((\.(\d){1,2}))?$/,
  capt: /^[0-9a-zA-Z]{4}$/,
  password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
}

export default (Vue) => {
  Vue.prototype.$validate = function (opts) {
    opts = Object.assign({
      rules: [],
      // msgField: 'errmsg',
      onInvalid (key, msg) {
        opts.msgField && (this[opts.msgField] = msg)
        this[key + 'Msg'] = msg
        let check = 'check' + key.substring(0, 1).toUpperCase() + key.substr(1, key.length)
        this[check] = false
      }
    }, opts)

    return validate(opts.rules, this, opts.onInvalid)
  }
  Vue.prototype.$validate.patterns = patterns
}



// WEBPACK FOOTER //
// ./src/plugins/validate.js